import { render, staticRenderFns } from "./SearchSwitcherWrapper.vue?vue&type=template&id=5f5f93b7&scoped=true&"
import script from "./SearchSwitcherWrapper.vue?vue&type=script&lang=js&"
export * from "./SearchSwitcherWrapper.vue?vue&type=script&lang=js&"
import style0 from "./SearchSwitcherWrapper.vue?vue&type=style&index=0&id=5f5f93b7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5f93b7",
  null
  
)

export default component.exports